import React from "react";

var changeSvg = function changeSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4.986 13.201V10.41a1 1 0 1 1 2 0V15a.998.998 0 0 1-1 1.001H1.4a1 1 0 0 1 0-2.002h1.29A8.003 8.003 0 0 1 0 8.008 8 8 0 0 1 5.716.327a1 1 0 1 1 .568 1.92A5.998 5.998 0 0 0 2 8.008 6.005 6.005 0 0 0 4.986 13.2zM11.014 2.8V5.59a1 1 0 1 1-2 0V1a.998.998 0 0 1 1-1.001H14.6a1 1 0 0 1 0 2.002h-1.29A8.003 8.003 0 0 1 16 7.992a8 8 0 0 1-5.716 7.68 1 1 0 1 1-.567-1.92A5.998 5.998 0 0 0 14 7.992 6.005 6.005 0 0 0 11.014 2.8z"
  }));
};

changeSvg.defaultProps = {
  height: "16",
  viewBox: "0 0 16 16",
  width: "16",
  xmlns: "http://www.w3.org/2000/svg"
};
export var change = {
  category: 'icon',
  colorable: true,
  name: 'change',
  svg: changeSvg
};